import { EpimsBaseEntityDto } from './epim-base.dto';

export class RequestMgmtCategoryDto extends EpimsBaseEntityDto {
  RequestMgmtCategoryId: string;

  RequestMgmtCategoryName: string;
  SubscriptionUserId: string;
}
